import React from 'react';
import Sidebar from '../components/sidemenu/sidebar';

const Home = () => {
  return (
    <div>
        <Sidebar/>
    </div>
  );
};

export default Home;